import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AdminLayout from '../../../components/AdminLayout/AdminLayout';
import DashboardMainContainer from '../../../components/common/Containers/DashboardMainContainer';
import {
  AdminPageTitle,
  AdminTabButton,
  ADMIN_TAB_CONTENT_CONTAINER_CLASS,
  ADMIN_FORM_PANEL_CLASS,
} from '../shared/adminUx';
import GeneralSettingsPanel from './GeneralSettings';
import PlatformControlsPanel from './PlatformControls';
import SecurityCompliancePanel from './SecurityCompliance';
import AdminNotificationsPanel from './AdminNotifications';
import DataRecoveryPanel from './DataRecoveryPanel';

const SETTINGS_TABS = [
  { path: '/admin/settings/general', label: 'General' },
  { path: '/admin/settings/platform-controls', label: 'Platform Controls' },
  { path: '/admin/settings/security', label: 'Security' },
  { path: '/admin/settings/alerts', label: 'Notifications' },
  { path: '/admin/settings/data-requests', label: 'Data Requests' },
];

function normalizePath(p) {
  return (p || '').replace(/\/+$/, '') || '/';
}

const AdminSettingsPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const pathname = normalizePath(location.pathname);

  const renderPanel = () => {
    switch (pathname) {
      case '/admin/settings/general':
        return <GeneralSettingsPanel />;
      case '/admin/settings/platform-controls':
        return <PlatformControlsPanel />;
      case '/admin/settings/security':
        return <SecurityCompliancePanel />;
      case '/admin/settings/alerts':
        return <AdminNotificationsPanel />;
      case '/admin/settings/data-requests':
      case '/admin/settings/data-recovery':
        return <DataRecoveryPanel />;
      default:
        return <GeneralSettingsPanel />;
    }
  };

  const tabActivePath = SETTINGS_TABS.some((t) => t.path === pathname)
    ? pathname
    : '/admin/settings/general';

  return (
    <AdminLayout>
      <div className="tp-container-main">
        <div>
        <AdminPageTitle>Settings</AdminPageTitle>

        <DashboardMainContainer className={ADMIN_FORM_PANEL_CLASS}>
          <div className="border-b border-lightgray">
            <div className="flex space-x-8 overflow-x-auto">
              {SETTINGS_TABS.map((tab) => (
                <AdminTabButton
                  key={tab.path}
                  active={tabActivePath === tab.path}
                  onClick={() => navigate(tab.path)}
                >
                  {tab.label}
                </AdminTabButton>
              ))}
            </div>
          </div>
        </DashboardMainContainer>

        <div className={ADMIN_TAB_CONTENT_CONTAINER_CLASS}>{renderPanel()}</div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminSettingsPage;
